module.exports = __webpack_public_path__ + "img/car_00037.768de519.jpg";